import { emailSchema, numberRequiredSchema, stringOptionalSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  showing_enthusiasm_and_attention: stringRequiredSchema,
  keeping_participants_engaged: stringRequiredSchema,
  modelling_skills_using_strategies: stringRequiredSchema,
  suggestion: stringOptionalSchema,
  email: emailSchema,
  name: stringRequiredSchema,
  therapist_head: numberRequiredSchema,
});

export default validationSchema;